import React, { useEffect, useState } from 'react';
import logo from './logo.svg';
import { getMatchupData, getNFLState, getStats, getTeamData } from './apiData';
import './App.css';
import { match } from 'assert';
import { error } from 'console';

export interface NFLState {
  week: number,
  year: number,
  season_type: string,
  currentWeek: number
}

export interface PlayerPoints {
  [playerId: string]: number;
}

export interface MatchupData {
  points: number;
  players: string[];
  roster_id: number;
  custom_points: number | null;
  matchup_id: number;
  starters: string[];
  starters_points: number[];
  players_points: PlayerPoints;
  hasHadStarter: boolean;
}

export interface TeamInfo {
  displayName: string,
  teamName: string,
  avatarPath: string,
  userID: string,
  rosterID: number
}

export interface IceData {
  rosterID: number,
  iceCount: number
}

const App: React.FC = () => {

  const defaultLeagueID = "1312111088506003456"   // 2026 DDD III
  const RETIRED_LEAGUE_IDS = new Set([
    "1247687949034733568",  // 2025
    "1264424642928459776",  // 2024
  ])

  const LEAGUE_ID_KEY = "theicewatch-leagueIDKey";

  const [leagueState, setLeagueState] = useState<NFLState | undefined>();
  const [matchupData, setMatchupData] = useState<MatchupData[] | undefined>();
  const [teamInfo, setTeamInfo] = useState<TeamInfo[] | undefined>();
  const [playersWithStats, setPlayersWithStats] = useState<string[] | undefined>();
  const [iceData, setIceData] = useState<IceData[] | undefined>();
  const [weekOffset, setWeekOffset] = useState<number>(0);
  const [shotguns, setShotguns] = useState<number[]>([]);
  const [weekStarted, setWeekStarted] = useState<boolean>(true);
  const [leagueID, setLeagueID] = useState<string>(() => {
    const stored = localStorage.getItem(LEAGUE_ID_KEY);
    return !stored || RETIRED_LEAGUE_IDS.has(stored) ? defaultLeagueID : stored
  });

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const iceCube = "🧊"
  const beer = "🍺"
  const weekOffsetKey = "iceWatch-weekOffset";

  // Settings modal state/handlers
  const [showSettings, setShowSettings] = useState(false);
  const [settingsValue, _setSettingsValue] = useState<string>("");

  const openSettings = () => setShowSettings(true);
  const closeSettings = () => setShowSettings(false);

  const updateLeagueID = (value: string) => {
    const trimmed = value.trim();
    if (!trimmed) 
    {
      return;
    }
    localStorage.setItem(LEAGUE_ID_KEY, trimmed);
    setLeagueID(trimmed);
    setShowSettings(false);
  };

  useEffect(() => {
    const run = async () => {
      try {
        setIsLoading(true);

        // localStorage value
        const weekOffsetRaw = localStorage.getItem(weekOffsetKey);
        const weekOffsetLocal = weekOffsetRaw !== null ? parseInt(weekOffsetRaw) : 0;

        // fetch NFL state
        const state = await getNFLState(weekOffsetLocal);
        setLeagueState(state);
        setWeekOffset(weekOffsetLocal);

        // fetch teams
        const teams = await getTeamData(leagueID);

        if (!teams) {
          handleBadLeagueID();
        } else {
          setTeamInfo(teams);
        }
      } catch (err) {
        console.error("Error in useEffect:", err);
      } finally {
        setIsLoading(false);
      }
    };

    run();
  }, [weekOffset, leagueID]);

  useEffect(() => {
    if (!leagueState) return;

    let cancelled = false;

    const run = async () => {
      try {
        const week = leagueState.currentWeek - weekOffset;
        const shouldGetStats =
          true;//weekOffset === 0 && leagueState.week === leagueState.currentWeek;

        const [matchups, stats] = await Promise.all([
          getMatchupData(leagueID, week),
          shouldGetStats
            ? getStats(leagueState.season_type, leagueState.year, week)
            : Promise.resolve<string[] | undefined>(undefined),
        ]);

        if (cancelled) return;

        setMatchupData(matchups);
        if (stats) setPlayersWithStats(stats);
      } catch (err) {
        console.error("Error loading matchup/stats:", err);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [leagueState, weekOffset, leagueID]);


  useEffect(() => {
    
    const iceData = checkForIces();

    setIceData(iceData);

  }, [matchupData, playersWithStats, weekOffset,leagueID]); 

  useEffect(() => {

        function addHasHadStartersFlag(m: MatchupData) {
        const hasHadStarter =
          
          m.starters?.some((playerID) => playersWithStats?.includes(playerID));

        return { ...m, hasHadStarter };
    }

    const matchupCopyWithStarterFlag = matchupData?.map(addHasHadStartersFlag);

    setMatchupData(matchupCopyWithStarterFlag)


  }, [playersWithStats, leagueID])

  const handleBadLeagueID = () => {
    console.log("got bad id")
    setLeagueID(defaultLeagueID)
    localStorage.setItem(LEAGUE_ID_KEY, defaultLeagueID)
  }

  const checkForIces = () => {

    let ices: IceData[] = [];

    // console.log("matchups:")
    // console.log(matchupData);
    // console.log("leaguestates:")

    // console.log(leagueState)

    if (!matchupData || leagueState?.season_type != "regular")
    {
      return;
    }

    let currentMin = 99999;

    let gamesFound = false;

    matchupData.forEach(m => {

      const rosterID = m.roster_id;

      if (m.points < currentMin && m.hasHadStarter)
      {
        currentMin = m.points
      }

      const zeroPoints = m.starters_points.filter(f => f === 0);

      if (zeroPoints.length !== m.starters_points.length)
      {
        gamesFound = true;
      }

      let iceCount = 0;
      m.starters_points.forEach((sp, index) => {

        const playerID = m.starters[index];

        if (sp < 0)
        {
          iceCount++;
        }

        if (sp === 0)
        {

          //player has played
          if (playersWithStats?.includes(playerID) || weekOffset !== 0) {
              iceCount++;
          }
        }
      })

      const iceLocal: IceData = {rosterID, iceCount};
      ices.push(iceLocal)
    });



    const shotguns = matchupData.filter(mm => mm.points === currentMin && mm.hasHadStarter).map(x => x.roster_id);

    setShotguns(shotguns);

    setWeekStarted(gamesFound);

    return ices;
  }

  const DisplayIces: React.FC = () => {
    const filteredIceData = iceData?.filter(i => i.iceCount > 0 || shotguns.includes(i.rosterID));
    
    const totalIces = filteredIceData?.reduce((sum, x) => sum + x.iceCount, 0);

    if (!weekStarted)
    {
      return (<div className='ice-text'>{`Relax, the week hasn't started`}</div>)
    }


    // if (leagueState?.season_type !== "regular")
    // {
    //   return (<div>{`Be patient.  No ices :/`}</div>)
    // }

    if (filteredIceData?.length === 0 || totalIces === undefined)
    {
      return (<div className='ice-text'>{`No ices :/`}</div>)
    }

    const totalIcesText = totalIces === 0 ? "No Ices :/" : `Ice Count: ${totalIces}`

    if (!weekStarted)
    {
      return (<div className='ice-text'>{`Relax, the week hasn't started`}</div>)
    }

    return (
      <div style={{userSelect: "none"}}>
        <div className='ice-text'>{totalIcesText}</div>
        <div>{iceCube.repeat(totalIces)}</div>
        <div className="ice-cards-container">
          {filteredIceData?.map(i => {
            const team = teamInfo?.find(ti => ti.rosterID === i.rosterID);
    
            return (
              <IceCard
                key={i.rosterID}
                teamName={team?.teamName}
                displayName={team?.displayName}
                iceCount={i.iceCount}
                avatarPath={team?.avatarPath}
                shotgun={shotguns.includes(i.rosterID)}
              />
            );
          })}
        </div>
      </div>

    );
  };

const teamNameCleaned = (displayName?: string, teamName?: string): string => {
  if (!teamName || teamName === "Unknown") {
    return `Team ${displayName?.replace(/[()]/g, "") ?? ""}`;
  }
  return teamName;
};
  

  const IceCard: React.FC<{ teamName?: string; displayName?: string; iceCount: number; avatarPath?: string; shotgun?: boolean }> = ({
    teamName,
    displayName,
    iceCount,
    avatarPath,
    shotgun
  }) => {
    return (
    <div className="ice-card">
      {avatarPath && <img src={avatarPath} className="team-avatar" />}
      <div className="ice-card-content">
        <div>{teamNameCleaned(displayName, teamName)}</div>
        <div>({displayName})</div>
        <div>
          {Array.from({ length: iceCount }, (_, idx) => (
            <span key={idx}>{iceCube}</span>
            
          ))}
          {shotgun ? beer : ""}
        </div>
      </div>
    </div>

  );
}

  const handlePreviousWeek = () => {
    if (weekOffset === leagueState?.currentWeek)
    {
      return;
    }
    const offetString = (weekOffset + 1).toString()

    setWeekOffset(weekOffset + 1)

    localStorage.setItem(weekOffsetKey, offetString);

  };

  const handleNextWeek = () => {
    if (weekOffset === 0)
    {
      return;
    }
    const offetString = (weekOffset - 1).toString()
    localStorage.setItem(weekOffsetKey, offetString);

    setWeekOffset(weekOffset - 1)
  };

  const resetOffset = () => {
    const offsetString = "0"
    localStorage.setItem(weekOffsetKey, offsetString);

    setWeekOffset(0);
  }

  const getWeekTextTitle = () => {
    if (leagueState?.season_type === "regular")
    {
      return `WEEK ${leagueState?.week}, ${leagueState?.year}`
    }
    else
    {
      return isLoading ? "Loading..." : "SEASON HAS NOT STARTED";
    }
  }

    const SettingsModal: React.FC<{
        title?: string;
        initialValue?: string;
        onOk: (value: string) => void;
        onCancel: () => void;
  }> = ({ title = "", initialValue = "", onOk, onCancel }) => {
        const [value, setValue] = useState(initialValue);
        const inputRef = React.useRef<HTMLInputElement>(null);

        useEffect(() => {
          inputRef.current?.focus();
          inputRef.current?.select();
          const onEsc = (e: KeyboardEvent) => e.key === "Escape" && onCancel();
          window.addEventListener("keydown", onEsc);
          return () => window.removeEventListener("keydown", onEsc);
        }, [onCancel]);

        return (
          <div className="modal-overlay" role="dialog" aria-modal="true" onClick={onCancel}>
            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">{title}</div>
              <div className="modal-body">
                <div className="modal-body-helptext">
                  {"Sleeper App -> Select league -> Top right gear icon -> General -> Scroll to button and click \"Copy League ID\""}
                </div>
                <label>
                  <input
                    ref={inputRef}
                    className="modal-input"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && onOk(value)}
                    placeholder="Enter Sleeper League ID…"
                  />
                </label>
                <div className="modal-actions">
                  <button className="modal-btn" onClick={onCancel}>Cancel</button>
                  <button className="modal-btn primary" onClick={() => onOk(value)} disabled={!value}>Change League</button>
                </div>
              </div>
            </div>
          </div>
        );
  };


  
  return (
    <div className="App">
      <header className="App-header">
        {iceCube} ICE WATCH {iceCube}
      </header>
      <main className="App-main">
      <div className="week-navigation">
        <button style ={{visibility: leagueState && leagueState?.week <= 1 ? 'hidden' : 'visible', userSelect:"none"}} onClick={handlePreviousWeek}>{isLoading ? "" : `<<`}</button>
        <div className="week-text" onClick={resetOffset}>
          {getWeekTextTitle()}
        </div>
        <button style ={{visibility: leagueState?.currentWeek === leagueState?.week ? 'hidden' : 'visible', userSelect:"none"}} onClick={handleNextWeek}>{isLoading ? "" : `>>`}</button>
      </div>
        {isLoading ? "" : <DisplayIces />}

      </main>

      {!showSettings && (
  <button
    className="settings-gear-btn"
    aria-label="Open settings"
    title="Settings"
    onClick={openSettings}
  >
    <span className="settings-text">Change League</span>
    <img
      src="/settings.png"
      alt="Settings"
      style={{ width: 24, height: 24 }}
    />
  </button>
      )}

      <div className='footer'>
        <a className='linkText' href="https://www.google.com/maps/search/?api=1&query=smirnoff+ice+near+me" target="_blank" rel="noopener noreferrer">
          Need an Ice?
        </a>
        

      {showSettings && (
        <SettingsModal
          initialValue={settingsValue}
          onOk={updateLeagueID}
          onCancel={closeSettings}
        />
      )}
      </div>
    </div>
  );
  
  
  
}

export default App;
